import React from 'react';
import loadable from '@loadable/component'

import withPage, { fetchSlugInfo } from '../page';

const MDP = loadable(() => import('./components'));

const loadData = async (urlParams, store, querySelector) => {
    const { dir, slug, filters } = urlParams;
    const fullSlug = `/${dir}/${slug}${filters ? '/'+filters : ''}`;
    await store.dispatch(fetchSlugInfo(fullSlug, querySelector));

    const { slugInfo, redirects, basename } = store.getState();

    const needRedirect = !slugInfo || slugInfo.error || (redirects && redirects.count !== 0);

    const { destination = `${basename}/slp/weekly-deals`, status = 301 } = redirects;
    if (needRedirect) return Promise.resolve({ status, destination });

    return Promise.resolve(slugInfo);
};

const MDPContainer = ({ slugInfo = {}}) => {
    const { featuresTabHtml, productTab={} } = slugInfo.components || {};
    
    const [ productGroup={} ] = (productTab.productGroups || []);
    const { productsList=[] } = (productGroup || {})
	return <MDP featuresTabHtml={featuresTabHtml} productsList={productsList} />
}

export default {
    component: withPage(MDPContainer, { wrapperClassName: 'mdp-root', showWordCloud: true, useV2: true }),
    loadData: loadData
};
